<template>
  <footer
    class="footer jipvio-footer"
    :class="{[`footer-${type}`]: type}"
    :data-background-color="backgroundColor"
  >
    <!--sohyun-->
    <div class="container">
      <div class="foot_container">
        <div style="float:left">
          <img src="/img/jipvio_foot_logo.png"
      />
        </div>
        <nav style="float:right">
          <ul class="jipvio-text-left jipvio-footer-nav">
            <li>
              <router-link to="/about">서비스소개</router-link>
            </li>
            <li>
              <router-link to="/terms">| &nbsp;이용약관</router-link>
            </li>
            <li>
              <router-link to="/privacy">| &nbsp;개인정보처리방침</router-link>
            </li>
          </ul>
        </nav>
      </div>
      <div class="jipvio-footer-info jipvio-text-left mb-10" style="clear:both;">
        <li>상호 : 집비오부동산중개 | 대표 : 유소현</li>
        <li>&nbsp;|&nbsp;</li>
        <li>사업자등록번호 : 509-03-27943</li>
        <li>&nbsp;|&nbsp;</li>
        <li>통신판매업신고번호 : 신고면제대상</li>
        <li>&nbsp;|&nbsp;</li>
        <li>중개사무소 등록번호 : 제11530-2020-00050호</li>
        <li>주소 : 서울특별시 구로구 고척로89, 1층(집비오부동산중개) (우)08252</li>
        <li>&nbsp;|&nbsp;</li>
        <li>전화 : 02-2688-3244 | 서비스 이용문의 : cs@jipvio.com</li>
        <li>고객지원 : 채팅 상담 (운영시간: 10:00~ 17:00 점심: 12:00-13:00)</li>
      </div>
      <div
        class="copyright cl-bth jipvio-text-left"
      >&copy; {{year}} <a href="/" style="color: inherit; cursor: pointer">집비오부동산중개 Co.</a> all rights reserved.</div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String,
  },
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
<style>
</style>
